import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-listing-cards',
  templateUrl: './listing-cards.component.html',
  styleUrls: ['./listing-cards.component.scss']
})
export class ListingCardsComponent implements OnInit {

  @Input() cardTitle: string;
  @Input()  cardContent : string;
  @Input() iconClass:string;
  @Input() cardId:string;
  @Input() cardValue:number;
  constructor() { }

  ngOnInit() {
  }


}
